"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class LocalStorage {
    constructor(parseToString, parseToJSON) {
        this.parseToString = JSON.stringify;
        this.parseToJSON = (value) => {
            try {
                if (typeof value === 'string')
                    return JSON.parse(value);
                return value;
            }
            catch (error) {
                return value;
            }
        };
        this.clear = localStorage.clear;
        this.length = localStorage.length;
        this.getAllKeys = () => Object.keys(localStorage);
        this.removeItem = (key) => localStorage.removeItem(key.toString());
        if (parseToString)
            this.parseToString = parseToString;
        if (parseToJSON)
            this.parseToJSON = parseToJSON;
    }
    getItem(key) {
        const value = localStorage.getItem(key.toString());
        return this.parseToJSON(value);
    }
    setItem(key, value) {
        return localStorage.setItem(key.toString(), this.parseToString(value));
    }
}
exports.default = LocalStorage;
//# sourceMappingURL=local-storage.js.map